<script setup>
import BackButton from 'dashboard/components/widgets/BackButton.vue';

defineProps({
  headerTitle: {
    required: true,
    type: String,
  },
  headerDescription: {
    type: String,
    default: '',
  },
  hasBackButton: {
    type: Boolean,
    default: false,
  },
});
</script>

<template>
  <!-- Cabecera de la tarjeta del informe. Los márgenes negativos la sacan
       del acolchado de ReportsWrapper para que ocupe todo el ancho al
       quedarse pegada arriba; si no, el contenido se vería pasar por los
       lados al desplazar. -->
  <header
    class="sticky top-0 z-10 flex flex-col gap-1 px-6 py-4 -mx-6 mb-5 border-b bg-n-solid-2 border-n-weak"
  >
    <div v-if="hasBackButton">
      <BackButton compact />
    </div>
    <div class="flex items-start justify-between w-full gap-5">
      <div class="flex flex-col gap-1 min-w-0">
        <span class="text-xl font-medium truncate text-n-slate-12">
          {{ headerTitle }}
        </span>
        <p v-if="headerDescription" class="mb-0 text-sm text-n-slate-10">
          {{ headerDescription }}
        </p>
      </div>
      <div class="flex-shrink-0">
        <slot />
      </div>
    </div>
  </header>
</template>
